import React from 'react';
import { Calendar } from 'lucide-react';
export function MockupSection() {
  return <section className="bg-dark py-20 px-4" data-id="element-81">
      <div className="max-w-[900px] mx-auto flex justify-center" data-id="element-82">
        <div className="bg-white border-2 border-accent rounded-xl p-8 md:p-12 max-w-2xl w-full text-center shadow-2xl relative overflow-hidden" data-id="element-83">
          <div className="absolute top-0 left-0 w-full h-2 bg-accent" data-id="element-84"></div>

          <div className="flex justify-center mb-6" data-id="element-85">
            <div className="bg-accent/10 p-4 rounded-full" data-id="element-86">
              <Calendar className="text-accent" size={48} data-id="element-87" />
            </div>
          </div>

          <h3 className="text-3xl md:text-4xl font-bold text-textDark mb-6" data-id="element-88">
            Juega Desde Otro Nivel
          </h3>

          <div className="space-y-3 text-lg text-textDark font-medium mb-8" data-id="element-89">
            <p data-id="element-90">90 minutos para ordenar cómo creces.</p>
            <p data-id="element-91">En vivo por Zoom</p>
            <p data-id="element-92">Sábado 18 de abril de 2026</p>
            <p data-id="element-93">10:00 a. m. Venezuela</p>
          </div>

          <div className="inline-block bg-accent text-white font-bold text-2xl py-3 px-8 rounded-full" data-id="element-94">
            Inversión: $15 USD
          </div>
        </div>
      </div>
    </section>;
}